
// redux/dashboard/dashboardApi.js
import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";

// standardized to "fetch" prefix
export async function fetchClientStatusApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.clientStatus}`, {
    params: payload,
  });
}

export async function fetchQueryTypeApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.queryType}`, {
    params: payload,
  });
}

export async function fetchSummaryApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.summary}`, {
    params: payload,
  });
}

export async function fetchUserStatusApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.userStatus}`, {
    params: payload,
  });
}

/* Takes params now. It ignored them, so `scope=me` never left the browser
   and the work-status menu asked the team-wide question instead of its own. */
export async function fetchActiveTasksApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.activeTasks}`, {
    params: payload,
  });
}

export async function fetchQueriesCountAndProductivityStarApi(payload) {
  // payload will contain { fromDate: "2026-04-22", toDate: "2026-04-22" }
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.yesterdayProductivityStar}`, {
    params: payload,
  });
}

export async function clockInApi(userId) {
  return await api.post(`${apiPath.API_URL}${apiPath.clockin.clockIn}`, {
    userId,
  });
}

export async function clockOutApi(userId) {
  return await api.post(`${apiPath.API_URL}${apiPath.clockin.clockOut}`, {
    userId,
  });
}

export async function workingHoursApi(userId) {
  return await api.get(`${apiPath.API_URL}${apiPath.clockin.workingHours}`, {
    params:{
      userId,
    },
  });
}

// UserId is resolved server-side from the auth token (authenticate middleware),
// so this only needs the Authorization header that the api interceptor adds.
export async function fetchAttendanceDashboardApi() {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.attendacneList}`);
}

export async function getStatusClockApi() {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.clock_status}`)
}

/* Everybody's clock for one day, for the dashboard roster panel.
   getStatusClockApi above answers for the signed-in user only. */
export async function getTeamClockStatusApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.teamClockStatus}`, {
    params,
  });
}

/* Page load: undo the tab-close punch if that is all that happened, otherwise
   clock in normally. See sp_Punch_ResumeSession. */
export async function resumeSessionApi() {
  return await api.post(`${apiPath.API_URL}${apiPath.clockin.resumeSession}`, {});
}


/* Break Hours split into Break / Lunch / Be right back. Defaults to the
   signed-in user and today; pass { fromDate, toDate } to widen it. */
export async function getBreakBreakdownApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.breakBreakdown}`, {
    params,
  });
}


/* The punching report. { fromDate, toDate, userCode? } — omit userCode for
   everybody. */
export async function getPunchingReportApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.punchingReport}`, {
    params,
  });
}

/* One team's pending rows. `noTeam` asks for the tasks that have no team at
   all, which is a real card on the panel and cannot be expressed by a code. */
export async function teamPendingTasksApi(params = {}) {
  const response = await api.get(apiPath.dashboard.teamPendingTasks, { params });
  return response.data;
}

/* Today's spells — every stretch at the desk and every break, with times. */
export async function fetchPunchSpellsApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.punchSpells}`, {
    params: payload,
  });
}

/* The same overview counted by project rather than by client. */
export async function fetchSummaryByProjectApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.summaryByProject}`, {
    params: payload,
  });
}
